import { lazyRouteComponent, createRoute } from '@tanstack/react-router';

import { processIncomingMobilityRoute } from '../route';

export const processIncomingMobilityBasicInfoRoute = createRoute({
	getParentRoute: () => processIncomingMobilityRoute,
	path: '/0-basic-info',
	component: lazyRouteComponent(
		() => import('./ProcessIncomingMobilityBasicInfoPage'),
		'ProcessIncomingMobilityBasicInfoPage',
	),
});
